import { render, staticRenderFns } from "./NormalSearchNav165.vue?vue&type=template&id=35bb72da&scoped=true"
import script from "./NormalSearchNav165.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav165.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb72da",
  null
  
)

export default component.exports